import { Box, Divider, Typography, Grid } from '@mui/material';
import { HubCard } from './HubCard';
import { useAppI18n } from '../../../i18n/use-app-i18n';
import type { NavigationCardDescriptor, TranslationKey } from '@finance/contracts';

export interface HubGroupProps {
  id: string;
  titleKey: TranslationKey;
  cards: NavigationCardDescriptor[];
  showDivider: boolean;
  isLast: boolean;
}

export function HubGroup({ id, titleKey, cards, showDivider, isLast }: HubGroupProps) {
  const { text } = useAppI18n();

  return (
    <Box key={id} className="hub-group" sx={{ mb: isLast ? 0 : 4 }}>
      {showDivider && <Divider sx={{ mb: 3 }} />}
      <Typography variant="subtitle1" component="h2" sx={{ mb: 2, fontWeight: 700 }}>
        {text(titleKey)}
      </Typography>

      <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
        {cards.map((card) => (
          <HubCard key={card.id} card={card} />
        ))}
      </Grid>
    </Box>
  );
}
